import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getFeatureEnabled, setFeatureState } from "./localStorage";
import { sendEntryToBrowserAddon } from "./communication";

const Feature = ({ name, expire, off, on }) => {
  const feature = window && window.features && window.features[name];
  const defaultState = getFeatureEnabled(name) || (feature && feature.on) || false;
  const [enabled, setEnabled] = useState(defaultState);

  sendEntryToBrowserAddon({ name, expire, value: enabled, type: "feature" });

  const handleMessageFromBrowserAddon = useCallback(
    (msg) => {
      if (
        msg.source == window &&
        msg.data.direction &&
        msg.data.direction == "from-ship"
      ) {
        const m = msg.data.message;
        if (m.command == "toggle") {
          if (m.feature == name && m.value != enabled) {
            setEnabled(m.value);
            setFeatureState(name, m.value);
            sendEntryToBrowserAddon({
              name,
              expire,
              value: m.value,
              type: "feature",
            });
          }
        }
      }
    },
    [setEnabled, enabled]
  );

  useEffect(() => {
    if (window) {
      window.addEventListener("message", handleMessageFromBrowserAddon);
    }
    return () => {
      if (window) {
        window.removeEventListener("message", handleMessageFromBrowserAddon);
      }
    };
  }, [handleMessageFromBrowserAddon]);

  if (window && enabled) {
    return on();
  }
  return off();
};

Feature.propTypes = {
  name: PropTypes.string.isRequired,
  expire: PropTypes.number.isRequired,
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
};

export default Feature;
